import request from "@/util/http"; // Excel下载模板

export var downloadTemplate = function downloadTemplate(type) {
  return "/admin/excel/download?type=".concat(type);
}; // Excel导出

export var excelExport = function excelExport(type) {
  return "/admin/excel/export?type=".concat(type);
}; // Excel导入

export var excelImport = function excelImport(type, param) {
  return request({
    headers: {
      "Content-Type": "multipart/form-data"
    },
    url: "/admin/excel/import?type=".concat(type),
    method: "post",
    data: param
  });
};